import { Component, OnInit } from '@angular/core';
import { Route, Router } from '@angular/router';
import { UtilityProvider } from 'app/providers/utility/utility';
import { GlobalService } from 'app/services/globalService';
import { RestWS } from 'app/services/restService';
import { FuseUtils } from '@fuse/utils';

@Component({
  selector: 'app-fake',
  templateUrl: './fake.component.html',
  styleUrls: ['./fake.component.scss']
})
export class FakeComponent implements OnInit {


  muestraLead: boolean = false;
  loading: boolean = false;
  user: any = {
    nombre: '',
    telefono: '',
    email: '',
    empresa: ''
  }
  nombre: any;
  telefono: any;
  empresa: any;
  email: any;

  llamadaLead() {
    this.muestraLead = true;
  }

  async makeCall(tipo) {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
      this.utils.openDialog("Vishing enviado.", "Version: " + tipo, false, false);
    }, 1000);
  }

  onFileSelected(event: any) {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
      this.utils.openDialog("Fichero subido con éxito", "Clonación en proceso", false, false);
    }, 1000);
  }

  subidaModelo() {
    this.utils.openDialog("Función no disponible.", "Contacte con ventas", false, false);
  }

  async descargarModelo() {
    let dataBytes = await this.http.getData();
    var a = document.createElement('a');
    //getting data from our div that contains the HTML table
    var data = 'data:application/vnd.ms-excel;base64,' + dataBytes.data;
    console.log(data);
    a.href = data;
    //setting the file name
    a.download = 'download.xls';
    //triggering the function
    a.click();
  }
  

  constructor(public http: RestWS, private utils: UtilityProvider, public globalService: GlobalService, public router: Router) { }

  ngOnInit(): void {
    if (!this.globalService.clienteAivoz) {
      this.router.navigateByUrl("/pages/auth/login");
    }
  }

}

